module.exports = __webpack_public_path__ + "img/2Dline.fb5ebe35.png";